export default __webpack_public_path__ + "static/2-e4778cb653650ebf2607c8991f0b4bcb.png";